/*
Remarquables-info loader — mirrors Android RemarquableInfo.kt.

Loads /data/remarquables-info.json (array of entries keyed by arbreId)
and exposes a Map<arbreId, RemarquableEntry> for the catalogue + detail
screens.
*/

import { fetchJson } from './fetchJson'

const kAssetPath = '/data/remarquables-info.json'  // canonical location served by the SW

export interface RemarquableEntry
{
	id: number
	qualif?: string  // ex. "Paysager" or "Historique" — the city's classification reason
	resume?: string
	desc?: string
	cultivar?: string
	annee?: number  // year planted, when known
}

let fEntries: Map<number, RemarquableEntry> | null = null  // memoized arbreId -> entry, null until first load

/*
Ensure remarquables-info is loaded and indexed by `id`. Idempotent.
Throws with context on fetch / JSON failure.
*/
export async function ensureRemarquablesInfo(): Promise<Map<number, RemarquableEntry>>
{
	if (fEntries) return fEntries
	const vArr = await fetchJson<RemarquableEntry[]>(kAssetPath)
	const vMap = new Map<number, RemarquableEntry>()
	for (const vEntry of vArr) vMap.set(vEntry.id, vEntry)
	fEntries = vMap
	return fEntries
}

/*
Snapshot accessor. Returns null when not yet loaded — caller treats as a
soft miss and shows a degraded UI.
*/
export function remarquableInfoFor(inArbreId: number): RemarquableEntry | null
{
	if (!fEntries) return null
	return fEntries.get(inArbreId) ?? null
}

/*
Return all entries as an array. Used by the catalogue screen which lists
every remarquable, regardless of whether the user has captured it.
*/
export function allRemarquables(): RemarquableEntry[]
{
	if (!fEntries) return []
	return [...fEntries.values()]
}
